<template>
	<div class="row items flex-row">
		<div class="columns column12">
			<div class="gallery-wrapper flex-row">
				<masonry-wall :items="items" :gap="16" :max-columns="3">
					<template #default="{ item, index }">
						<div
							:key="index"
							class="filter-item"
							:class="{ active: filter === item.galleryCategory.ID || filter === 'showAll' }"
						>
							<a
								v-if="item.imagePortrait"
								:data-src="item.imagePortrait"
								class="gallery-item"
								data-fancybox="gallery"
								:data-caption="item.imagePortraitAlt"
								:title="item.imagePortraitAlt"
							>
								<picture>
									<source
										v-if="item.imagePortraitWebp"
										:srcset="item.imagePortraitWebp"
										type="image/webp"
									/>
									<source :srcset="item.imagePortrait" />
									<img :src="item.imagePortrait" :alt="item.imagePortraitAlt" loading="lazy" />
								</picture>
							</a>
							<a
								v-else-if="item.imageLandscape"
								:data-src="item.imageLandscape"
								class="gallery-item"
								data-fancybox="gallery"
								:data-caption="item.imageLandscapeAlt"
								:title="item.imageLandscapeAlt"
							>
								<picture>
									<source
										v-if="item.imageLandscapeWebp"
										:srcset="item.imageLandscapeWebp"
										type="image/webp"
									/>
									<source :srcset="item.imageLandscape" />
									<img :src="item.imageLandscape" :alt="item.imageLandscapeAlt" loading="lazy" />
								</picture>
							</a>
							<a
								v-else-if="item.embedCode"
								:data-src="item.embedCode"
								class="gallery-item fancybox iframe"
								:data-caption="item.header"
								:title="item.header"
							>
								<iframe
									:src="`${item.embedCode}?&amp;badge=0&amp;autoplay=0&amp;controls=1&amp;autopause=0&amp;player_id=0`"
									frameborder="0"
									allow="autoplay; fullscreen; picture-in-picture"
									allowfullscreen
									style="width: 100%; height: 100%"
									:title="item.header"
								/>
							</a>
						</div>
					</template>
				</masonry-wall>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.gallery-wrapper {
	padding: 50px 0 100px;

	.filter-item {
		margin: 0;
		cursor: pointer;
	}

	a {
		border: none !important;

		&::after {
			display: none;
		}
	}
}

iframe {
	width: calc(100%) !important;
	max-width: calc(33vw - 40px) !important;
	height: calc((33vw - 40px) / 16 * 9) !important;
}

@media (max-width: 1314px) {
	iframe {
		max-width: calc(50vw - 40px) !important;
		height: calc((50vw - 40px) / 16 * 9) !important;
	}
}

@media (max-width: 890px) {
	iframe {
		max-width: calc(100vw - 40px) !important;
		height: calc((100vw - 40px) / 16 * 9) !important;
	}
}
</style>
